<template>
  <div class="animated fadeIn">
    <b-alert :variant="dismissibleType"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ errMsg }}
    </b-alert>
    <div>
      <b-row>
        <b-col md="8">
          <b-card>
            <template v-slot:header>
              <strong>Rebate Regions</strong>
            </template>
            <b-table :items="filteredData" :fields="fields" hover striped bordered small caption-top responsive
                     @filtered="onFiltered" show-empty :current-page="currentPage" :per-page="perPage">
              <template v-slot:table-caption>
                <b-row class="px-0 mx-0">
                  <b-col md="3">
                    <b-form-group>
                      <b-input-group>
                        <b-form-input v-model="filter" placeholder="Type to Search" />
                        <b-input-group-append>
                          <b-btn @click="filter = ''">Clear</b-btn>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-button class="pull-right" variant="outline-success" v-b-modal.addRebateRegion title="Add">
                      <i class="fa fa-plus-square"></i> <strong>Add</strong>
                    </b-button>
                  </b-col>
                </b-row>
              </template>
              <template v-slot:cell(SelectedRegion)="data">
                <slot v-if="!data.item.edit">{{data.item.SelectedRegion}}</slot>
                <b-form-select v-if="data.item.edit" v-model="data.item.Region.RegionId"
                               :options="data.item.AvailableRegions" value-field="RegionID" text-field="Name" />
              </template>

              <template v-slot:cell(Actions)="data">
                <button class="btn btn-warning text-white" v-if="!data.item.edit" @click="Delete(data.item)" title="Delete">
                  <i class="fa fa-remove"><strong> Delete</strong></i>
                </button>
              </template>
            </b-table>
            <b-row>
              <b-col class="mx-0">
                <nav>
                  <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" />
                </nav>
              </b-col>
              <b-col><div class="pull-right my-2" v-if="regions">Showing {{ totalRows}} / {{ regions.length }} records</div></b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <b-modal id="addRebateRegion" ref="addRebateRegion" size="md" title="Add Rebate Region" ok-title="Add" @ok="modalOK($event)">
      <b-container fluid>
        <b-row class="mb-1">
          <b-col class="text-right" cols="4">Manufacturer</b-col>
          <b-col>
            <b-form-select v-model="newregion.ManufacturerId" :options="newregion.Manufacturer" value-field="ID" text-field="Name"
                           v-bind:class="{'is-invalid': validateErrors.has('ManufacturerId') }"
                           v-validate="{required: true, excluded:0}" name="ManufacturerId" />
            <em class="error invalid-feedback">{{ validateErrors.first('ManufacturerId') }}</em>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col class="text-right" cols="4">Zipcode</b-col>
          <b-col class="pull-left">
            <b-form-input v-model="newregion.Zipcode" v-bind:class="{'is-invalid': validateErrors.has('Zipcode') }"
                          v-validate="{required: true}" name="Zipcode" />
            <em class="error invalid-feedback">{{ validateErrors.first('Zipcode') }}</em>
          </b-col>
          <b-col>
            <b-button class="pull-right my-1" variant="secondary" title="Find" @click="loadAvailableRegions">
              <i class="fa fa-search"></i> <strong>Find</strong>
            </b-button>
          </b-col>
        </b-row>
        <b-row class="mb-1" v-if="newregion.AvailableRegions">
          <b-col class="text-right" cols="4">Region</b-col>
          <b-col>
            <b-form-select v-if="newregion.AvailableRegions.length > 0"
                           v-model="newregion.RegionId" :options="newregion.AvailableRegions" value-field="RegionID" text-field="Name"
                           v-bind:class="{'is-invalid': validateErrors.has('RegionId') }"
                           v-validate="{required: true, excluded: 0}" name="RegionId" />
            <em class="error invalid-feedback">{{ validateErrors.first('RegionId') }}</em>
            <span v-if="newregion.AvailableRegions.length === 0">No Regions</span>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
    <loading :show="boolLoading" label="Loading..."></loading>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import loading from 'vue-full-loading'

export default {
  components: {
    loading
  },
  created () {
    var self = this
    self.boolLoading = true
    axios.get('/api/rebateregions/getall')
      .then(response => {
        self.boolLoading = false
        self.newregion.Manufacturer = self.newregion.Manufacturer.concat(response.data.manufacturer)
        console.log(response.data.manufacturer)
        self.regions = response.data.regions.map(x => {
          x['Zipcode'] = x.Region.Zipcode
          x['originalregionid'] = x.Region.RegionId
          x['edit'] = false
          return x
        })
        self.totalRows = self.regions.length
      })
      .catch(error => {
        self.SetErrorMsg(error, 'getting')
      })
  },
  data () {
    return {
      errMsg: '',
      dismissibleType: 'danger',
      showDismissibleAlert: false,
      boolLoading: false,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      regions: [],
      fields: [
        { key: 'Manufacturer', label: 'Manufacturer', tdClass: 'w100', sortable: true },
        // { key: 'Zipcode', label: 'Zipcode', tdClass: 'w100', sortable: true },
        { key: 'SelectedRegion', label: 'Region', tdClass: 'w100', sortable: true },
        { key: 'Actions', label: 'Actions', sortable: false, tdClass: 'w100' }
      ],
      filter: null,
      newregion: { ManufacturerId: 0, Manufacturer: [{ ID: 0, Name: 'Select One' }], Zipcode: '', AvailableRegions: null, RegionId: 0 }
    }
  },
  methods: {
    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    loadAvailableRegions () {
      var self = this
      Promise.all([
        this.$validator.validate('ManufacturerId', self.newregion.ManufacturerId),
        this.$validator.validate('Zipcode', self.newregion.Zipcode)
      ]).then(values => {
        if (values.every(value => { return value })) {
          self.boolLoading = true
          var obj = { ManufacturerId: self.newregion.ManufacturerId, Zipcode: self.newregion.Zipcode }
          axios.post('/api/rebateregions/findregions', obj)
            .then(response => {
              self.boolLoading = false
              self.newregion.AvailableRegions = response.data.availableregions
              self.newregion.ManufacturerId = response.data.manufacturerid
            })
            .catch(error => {
              self.SetErrorMsg(error, 'getting')
            })
        }
      })
    },
    modalOK (arg) {
      arg.preventDefault()
      var self = this

      Promise.all([
        this.$validator.validate('ManufacturerId', self.newregion.ManufacturerId),
        this.$validator.validate('Zipcode', self.newregion.Zipcode),
        this.$validator.validate('RegionId', self.newregion.RegionId)
      ]).then(values => {
        if (values.every(value => { return value })) {
          self.$refs.addRebateRegion.hide()
          self.boolLoading = true
          axios.post('/api/rebateregions/addregion', self.newregion)
            .then(response => {
              self.boolLoading = false
              location.reload()
            })
            .catch(error => {
              self.SetErrorMsg(error, 'saving')
            })
        }
      })
    },
    Edit (data) {
      data.edit = true
    },
    Cancel (data) {
      data.edit = false
      data.Region.RegionId = data.originalregionid
    },
    Update (data) {
      var self = this
      if (data.Region.ManufacturerId <= 0 || data.Region.RegionId <= 0 || data.Region.Zipcode.length <= 0) {
        alert('Data missing')
        return
      }

      self.boolLoading = true
      axios.post('/api/rebateregions/updateregion', data.Region)
        .then(response => {
          data.edit = false
          self.boolLoading = false
          location.reload()
        })
        .catch(error => {
          self.SetErrorMsg(error, 'saving')
        })
    },

    Delete (data) {
      var self = this

      if (data.Region.ManufacturerId <= 0 || data.Region.RegionId <= 0 || data.Region.Zipcode.length <= 0) {
        alert('Data missing')
        return
      }

      self.boolLoading = true
      axios.post('/api/rebateregions/deleteregion', data.Region)
        .then(response => {
          self.boolLoading = false
          location.reload()
        })
        .catch(error => {
          self.SetErrorMsg(error, 'deleting')
        })
    },
    SetErrorMsg (error, action) {
      var self = this

      if (error.response.status === 403 && error.response.statusText.indexOf('403.1') === -1) { self.$router.push('/login') }

      self.boolLoading = false

      self.errMsg = 'There was an error ' + action + ' your changes : '
      if (error !== undefined && error.response !== undefined && error.response.statusText !== undefined) {
        self.errMsg = self.errMsg + error.response.statusText
      } else {
        self.errMsg = self.errMsg + error
      }

      self.dismissibleType = 'danger'
      self.showDismissibleAlert = true

      if (error.response.status == 403 && error.response.statusText.indexOf('403.1') !== -1) { self.errMsg = error.response.statusText.replace('403.1', '') }
    }
  },
  computed: {
    filteredData: function () {
      if (this.boolLoading) {
        return this.regions
      } else {
        if (this.filter) {
          var f = this.filter.toLowerCase()
          return this.regions.filter(r => r.Manufacturer.toLowerCase().indexOf(f) >= 0 ||
                                            r.Region.Zipcode.toLowerCase().indexOf(f) >= 0 ||
                                            r.SelectedRegion.toLowerCase().indexOf(f) >= 0)
        } else {
          return this.regions
        }
      }
    }
  },
  mounted () {
    // boolLoading must be set to false on data() binding so that mount hooks the change
    this.boolLoading = true
  }
}
</script>

<style>
  .table > tbody > tr > td {
    vertical-align: middle;
  }

  .w100 {
    width: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/views/RebateRegions.vue